/*
 * @Author: zhaozhuo
 * @Date: 2021-10-11 16:49:24
 * @LastEditors: zhangquanming 419654548@qq.com
 * @LastEditTime: 2024-02-21 18:25:59
 * @Description: file content
 * @FilePath: \edc-mobile-web\src\router\index.js
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import locals from '@/local'
import baseRoute from './baseRoute'
import doctorRoute from './doctorRoute'
import patientRoute from './patientRoute'
import * as dictionary from '@/assets/js/dictionary'
import { wxAuth } from '@/assets/js/wxAuth'
Vue.use(VueRouter)
const routes = [{
	path: '/main',
	component: () => import('../views/Main.vue'),
	children: [...doctorRoute, ...patientRoute]
}, ...baseRoute]
const router = new VueRouter({
	routes
})
router.beforeEach((to, from, next) => {
	if (['/customTemplatePreviewRedict', '/follow', '/404', '/qrcode', '/preach'].includes(to.path)) {
		next()
		return
	} else {
		if (to.query.openId) {
			locals.setUserOpenId(to.query.openId)
			isLogin(to, from, next)
		} else {
			if (!locals.getUserOpenId()) {
				wxAuth().then(res => {
					if (res.code == 200) {
						locals.setUserOpenId(res.msg)
						isLogin(to, from, next)
					} else if (res.code == 502) {
						next({ path: '/follow' })
					} else {
						next({ path: '/404' })
					}
				}).catch(err => {
					console.log(err)
					next({ path: '/404' })
				})
			} else {
				next()
			}
		}
	}
})
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}
function isLogin(to, from, next) {
	if (!locals.getIdentityType()) {
		next({ path: '/home' })
		return
	}
	if (locals.getIdentityType() === dictionary.identityType[1].value || to.meta.isDoctor) {
		const token = locals.getUserToken()
		if (token) {
			next()
		} else {
			if (to.path !== '/login') {
				const url = encodeURIComponent(window.location.href)
				next({
					path: '/login',
					query: {
						redirectUrl: url
					}
				})
			} else {
				next()
			}
		}
	} else {
		next()
	}
}
export default router
